export default {
  zh: {
    myReward: '我的奖励',
    CNY: '￥',
    minAmount: '*最低提现金额 ￥100',
    submit: '提交申请',
    your: '您提交的',
    transferAccounts: '提现申请我们已受理，佣金将于最晚 15 号转账到',
    expirationDate: ' 。',
    insufficientCommission: '佣金不足',
    sure: '确定',
    ok: '确定'
  },
  en: {
    myReward: 'My Reward',
    USD: '$',
    minAmount: '*Min amount of cash withdrawal $ 50',
    submit: 'Submit',
    your: 'We have received your withdrawal application for ',
    transferAccounts: ', the commission will be transferred to your account',
    expirationDate: 'before 15th.',
    insufficientCommission: 'Insufficient Commission',
    sure: 'Sure'
  }
}



// WEBPACK FOOTER //
// ./src/components/withdraw/lang.js